<template>
  <div class="booking-app" :class="{ 'is-embedded': embedMode }" v-bind="embedMode ? { 'data-iframe-height': '' } : {}">
    <header v-if="!embedMode" class="booking-header">
      <div class="header-content">
        <div class="logo">{{ $t('appName') }}</div>
        <div class="header-actions">
          <label class="lang-label">{{ $t('language') }}</label>
          <select v-model="$i18n.locale" class="lang-select">
            <option value="en">EN</option>
            <option value="zh">中文</option>
          </select>
          <div class="header-badge">{{ $t('selfBooking') }}</div>
        </div>
      </div>
    </header>
    <main class="booking-main">
      <router-view />
    </main>
  </div>
</template>

<script>
export default {
  name: 'BookingApp',
  inject: {
    embedMode: { default: false }
  }
}
</script>

<style>
*, *::before, *::after {
  box-sizing: border-box;
  margin: 0;
  padding: 0;
}

body {
  font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, 'Helvetica Neue', Arial, sans-serif;
  background: #f5f7fa;
  color: #1e336f;
  -webkit-font-smoothing: antialiased;
}

body.is-booking-embedded {
  background: transparent;
}

html.is-booking-embedded,
body.is-booking-embedded {
  width: 100%;
}

.booking-app {
  min-height: 100vh;
}

.booking-app.is-embedded {
  min-height: 0;
  width: 100%;
  background: transparent;
}

.booking-app.is-embedded .booking-main {
  width: 100%;
  max-width: none;
  margin: 0;
  padding: 16px 20px 32px;
}

@media (min-width: 769px) {
  .booking-app.is-embedded .booking-main {
    padding: 24px 32px 48px;
  }
}

@media (min-width: 1024px) {
  .booking-app.is-embedded .booking-main {
    padding: 28px 40px 56px;
  }
}

.booking-header {
  background: #1e336f;
  color: #fff;
  padding: 16px 20px;
  position: sticky;
  top: 0;
  z-index: 100;
}

.header-content {
  max-width: 680px;
  margin: 0 auto;
  display: flex;
  align-items: center;
  justify-content: space-between;
}

.logo {
  font-size: 16px;
  font-weight: 700;
  letter-spacing: 2px;
}

.header-badge {
  font-size: 11px;
  font-weight: 600;
  letter-spacing: 1.5px;
  background: rgba(255,255,255,0.15);
  padding: 4px 10px;
  border-radius: 4px;
}

.header-actions {
  display: flex;
  align-items: center;
  gap: 8px;
}
.lang-label {
  font-size: 11px;
  opacity: .9;
}
.lang-select {
  border: 1px solid rgba(255,255,255,.35);
  background: rgba(255,255,255,.12);
  color: #fff;
  border-radius: 6px;
  font-size: 12px;
  padding: 4px 6px;
}

.booking-main {
  max-width: 680px;
  margin: 0 auto;
  padding: 24px 16px 40px;
}

@media (min-width: 769px) {
  .booking-main {
    padding: 32px 24px 60px;
  }
}
</style>



// WEBPACK FOOTER //
// src/BookingApp.vue